import { isAfter, isEqual, startOfDay } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'
import {
  GetGiveawayScheduleQuery,
  SweepstakesEntriesTypes,
  SweepstakesScheduleItemObject,
} from '@/types/codegen-federation'

export const isVerifiedHot = (audienceScore: number) => audienceScore >= 90

const findSchedule = (schedules: SweepstakesScheduleItemObject[] | null | undefined, type: SweepstakesEntriesTypes) => {
  if (!schedules) return null
  if (type === 'NORMAL') {
    return schedules.find((schedule) => schedule.ticketType === 'NORMAL' && schedule.itemType === 'TEMPORAL_ONLY')
  }

  return schedules.find((schedule) => schedule.ticketType === type)
}

const getQuantityMultipliers = (schedules: SweepstakesScheduleItemObject[] | null | undefined) => {
  if (!schedules) return null

  const quantitySets = schedules.filter((schedule) => schedule.itemType === 'QUANTITY')

  if (!quantitySets || quantitySets.length === 0) return null

  return quantitySets.map((set) => {
    return {
      min: set?.quantityMin ?? 1,
      max: set?.quantityMax ?? Infinity,
      multiplier: set.multiplier,
    }
  })
}

export const isGiveawayActive = (endDate: Date) => {
  const timeZone = 'America/Denver'
  const parsedEndDate = toZonedTime(new Date(endDate), timeZone)
  const startOfEndDate = startOfDay(parsedEndDate)
  const startOfToday = startOfDay(toZonedTime(new Date(), timeZone))
  return isEqual(startOfEndDate, startOfToday) || isAfter(startOfEndDate, startOfToday)
}

export const resolveGiveawaySchedule = (data: GetGiveawayScheduleQuery | undefined) => {
  const giveawaySchedule = data?.ticketSalesPromos?.sweepstakesSchedule?.[0]
  const schedules = giveawaySchedule?.items
  return {
    isActive: giveawaySchedule?.endDate ? isGiveawayActive(giveawaySchedule.endDate) : false,
    presale: findSchedule(schedules, 'PRESALE') ?? null,
    normal: findSchedule(schedules, 'NORMAL') ?? null,
    guildSubscription: findSchedule(schedules, 'GUILD_SIGNUP_MONTHLY') ?? null,
    guildTicketRedemption: findSchedule(schedules, 'GUILD_TICKET') ?? null,
    dailyBonusEntries: giveawaySchedule?.dailyBonusEntries ?? 0,
    minRewardTicketQuantity: giveawaySchedule?.minRewardTicketQuantity ?? 0,
    quantityMultipliers: getQuantityMultipliers(schedules) ?? null,
  }
}
